import { sessionDetails } from '../../../models/GSessions';
import { getRSVPsToEvent } from '../../../models/event/eventModel';
import {EventFullInfo} from '../../../models/event';
import {ETypeNum} from "../../../models/event/EType";
import {alphabetizeArray} from '../../../utils/arr';
import {strArrayToString} from '../../../utils/str';
import React from 'react';
import * as stringConstants from './GSessionViewModalConstants';
import moment from 'moment';



interface GSessionViewModalProps
{
    requestClose: () => void,
    requestEdit: () => void,
    session: sessionDetails,
    event: EventFullInfo
    playerNames: string[],
    user_id?: number,
    user_name?: string,
    onRelinquishSlot: () => void,
    onSignUp: () => void,
    canUserEdit: boolean
}


const GSessionViewModal = (props: GSessionViewModalProps) =>
{

    const [signUpSection, setSignUpSection] = React.useState<JSX.Element>(<p>Loading...</p>);
    const [participantArray, setParticipantArray] = React.useState<string[] | undefined>();
    const [participantString, setParticipantString] = React.useState<string>("(all slots available)");
    

    const occupiedSlots = props.playerNames.length;
    const totalSlots = props.session.slots + occupiedSlots;
    const userIsSignedUp = props.user_name ? props.playerNames.includes(props.user_name) : false;

    const SignUpBlob = async (uid: number | undefined , gSes: sessionDetails, isPermitted: boolean, sesEvent: EventFullInfo, userSignedUp: boolean, slots: number) =>
    {

        const sessionInPast = gSes.start < new Date();
        const noUser = uid === undefined;
        const thisUserSignedUp = userSignedUp === true;
        const userNotPermitted = isPermitted === false;
        const noSlotsRemaining = slots === 0;


        switch (sesEvent.eType) 
        {
            case ETypeNum.Premiere || ETypeNum.Plus:

                const prmEventList = await getRSVPsToEvent(sesEvent.id); //For now, but will change once registration behaivor is up

                const prmNotAttendingEvent = prmEventList?.data.filter((usr) => usr.id === props.user_id).length === 0;

                if (sessionInPast || noUser)
                {
                    const message =
                    [
                        (sessionInPast ? stringConstants.PRM_SESSION_IN_PAST_STRING : []),
                        (noUser ? stringConstants.PRM_NO_USER_LOGIN_STRING : []),
                    ].join('\n');

                    return(<p>{message}</p>)
                }
                else if (thisUserSignedUp)
                { // TODO: refactor props.onRelinquishSlot with GACntxt so that the sign-up/relinquish button does not need drill props down to this level
                    return(<button className="buttonPrimary" onClick={() => props.onRelinquishSlot()}>{stringConstants.PRM_RELINQUISH_BUTTON_STRING}</button>)
                }
                else if (prmNotAttendingEvent || userNotPermitted || noSlotsRemaining)
                {
                    const message =
                    [
                        (prmNotAttendingEvent ? stringConstants.PRM_NOT_RSVPED_EVENT_STRING : []),
                        (!prmNotAttendingEvent && userNotPermitted ? stringConstants.PRM_USER_NOT_PERMITTED_STRING : []),
                        (noSlotsRemaining ? stringConstants.PRM_NO_SLOTS_REMAINING_STRING : [])
                    ].join('\n');

                    return(<p>{message}</p>)
                }
                else
                {
                    return <button className="buttonPrimary" onClick={() => props.onSignUp()}>{stringConstants.PRM_SIGN_UP_BUTTON_STRING}</button>
                }


            case ETypeNum.Standard:

                const eventList = await getRSVPsToEvent(sesEvent.id)

                const notAttendingEvent = eventList?.data.filter((usr) => usr.id === props.user_id).length === 0;

                if (sessionInPast || noUser)
                {
                    const message =
                    [
                        (sessionInPast ? stringConstants.STD_SESSION_IN_PAST_STRING : []),
                        (noUser ? stringConstants.STD_NO_USER_LOGIN_STRING : []),
                    ].join('\n');

                    return(<p>{message}</p>)
                }
                else if (thisUserSignedUp)
                {
                    return(<button className="buttonPrimary" onClick={() => props.onRelinquishSlot()}>{stringConstants.STD_RELINQUISH_BUTTON_STRING}</button>)
                }
                else if (notAttendingEvent || userNotPermitted || noSlotsRemaining)
                {
                    const message =
                    [
                        (notAttendingEvent ? stringConstants.STD_NOT_RSVPED_EVENT_STRING : []),
                        (!notAttendingEvent && userNotPermitted ? stringConstants.STD_USER_NOT_PERMITTED_STRING : []),
                        (noSlotsRemaining ? stringConstants.STD_NO_SLOTS_REMAINING_STRING : [])
                    ].join('\n');

                    return(<p>{message}</p>)
                }
                else
                {
                    return <button className="buttonPrimary" onClick={() => props.onSignUp()}>{stringConstants.STD_SIGN_UP_BUTTON_STRING}</button>
                }
        }
        

    }





    React.useEffect(() =>
    {
        setParticipantArray(alphabetizeArray(props.playerNames, false));
        setParticipantString(strArrayToString(props.playerNames, ", ", "@"));

        SignUpBlob(props.user_id, props.session, true, props.event, userIsSignedUp, props.session.slots).then((res) => 
            {
                res && setSignUpSection(res);
            });
    }, [props])

    

    return(
        <div>
            <div className="modalContent">
                <h1>{props.session.name}</h1>

                <h2>Start Time</h2>
                <p>{moment(props.session.start).format("ddd hh:mm A")}</p>

                <h2>End Time</h2>
                <p>{moment(props.session.end).format("ddd hh:mm A")}</p>

                <h2>BGG Title Link</h2>
                <p>{props.session.bgg_title_link ? props.session.bgg_title_link : "(none provided)"}</p>

                <h2>Session Information</h2>
                <p>{props.session.info}</p>

                <h2>Table Number</h2>
                <p>{props.session.table}</p>

                <h2>Total Player Slots</h2>
                <p>{totalSlots}</p>

                <h2>Current Participants</h2>
                <p>{participantString}</p>

                <h2>Remaining Player Slots</h2>
                <p>{props.session.slots}</p>

                <h2>Event Host</h2>
                <p>{props.session.owner}</p>
            </div>

            <div className="modalButtons">
                {signUpSection}

                {props.canUserEdit && <button className="buttonPrimary" onClick={() => props.requestEdit()}>Edit Session</button>}
                <button className="buttonPrimary" onClick={() => props.requestClose()}>Back to Calendar</button>
            </div>
        </div>
    )
}

export default GSessionViewModal;
